<p><span [i18nKey]="labelKey"></span> <b><span class="note">{{displayedMark | number:'1.2'}}</span> / {{maximumMark}}</b></p>
